import { FC, memo, useState } from 'react'

import { HistoryTable } from 'bank-entity-history'
import { Accordion, DateTime, IconName, Layer, TextMask } from 'ui/components'

import * as SC from '../../styles'
import { KeyAddedInfoIcon } from '../../styles'
import { ConnectionsDetailsFormPayload, ConnectionsDetailsWebPage, DutchieCollectionData } from '../../types'
import { ConnectionsTable } from '../ConnectionsTable'

type Props = {
  collection: DutchieCollectionData
  payload: ConnectionsDetailsFormPayload
  setPayload: (payload: ConnectionsDetailsFormPayload) => void
  getWebPage: (payload: ConnectionsDetailsFormPayload) => Promise<ConnectionsDetailsWebPage>
}

export const DutchieCollection: FC<Props> = memo((props) => {
  const { collection, payload, getWebPage, setPayload } = props
  const [isLoading, setIsLoading] = useState(false)
  return (
    <SC.Section>
      <Layer shadowed rounded>
        <SC.TableHeader>
          <SC.TableKey>
            Key <TextMask fullyHidden text={collection.key} />
          </SC.TableKey>
          <SC.TableKeyInfo>
            <KeyAddedInfoIcon name={IconName.INFO_ROUND} /> Key was added{' '}
            <DateTime date={collection.keyAddedDate} withTime />
          </SC.TableKeyInfo>
        </SC.TableHeader>
        <ConnectionsTable connections={collection.connections} />
      </Layer>
      <Layer shadowed rounded>
        <Accordion title="View history" expanded={false} isGrey>
          <HistoryTable
            loading={isLoading}
            // eslint-disable-next-line
            // @ts-ignore
            dataQa={`history_${collection.id}`}
            items={collection.history}
            pagination={{
              total: collection.historyTotalCount,
              page: payload.dutchieHistoryPages[collection.id],
              size: payload.dutchieHistorySizes[collection.id],
              tooMany: collection.historyTotalCount === 10001,
              onChange: async (page: number, size: number) => {
                const newPayload = { ...payload }
                newPayload.dutchieHistoryPages[collection.id] = page
                newPayload.dutchieHistorySizes[collection.id] = size
                setPayload(newPayload)
                setIsLoading(true)
                await getWebPage(newPayload)
                setIsLoading(false)
              }
            }}
          />
        </Accordion>
      </Layer>
    </SC.Section>
  )
})
